// Este archivo es generado automáticamente por set-env.js
// No editar manualmente - configurar en .env

export const environment = {
  production: true,
  backendUrl: 'https://mapoh.187.127.19.11.nip.io',
  apiPrefix: '/api/v1',
  apiBaseUrl: 'https://mapoh.187.127.19.11.nip.io/api/v1',
  enableLogging: true,
  version: '1.0.0'
};
